<template>
	<div>
		<p
			class="text-smaller pb-4"
		>{{$t('Tájékoztatjuk, hogy korábban megadott jelszava lejárt, vagy jelszava megváltoztatását kérte. Kérjük adja meg új jelszavát')}}</p>

        <form @submit.prevent.stop="submit()">

            <div class="form-group form-group--password form-group--with-icon">
				<input
					ref="password"
					v-model.trim="$v.keyAndPassword.newPassword.$model"
					v-input-class
					:type="showPassword? 'text' : 'password'"
					class="input"
					:placeholder="$t('Jelszó')"
				/>
				<span class="input__icon">
                    <inline-svg :src="require('@/assets/icons/lock.svg')"></inline-svg>
				</span>
                <button
					type="button"
					@click.prevent.stop="showPassword = !showPassword"
					class="input__show-password"
				>
                    <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
				</button>
                <div>
                    <password v-model="keyAndPassword.newPassword" :secureLength="8" :strength-meter-only="true"/>
                </div>
				<div class="input__error" v-show="$v.keyAndPassword.newPassword.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.keyAndPassword.newPassword.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span v-else-if="!$v.keyAndPassword.newPassword.minLength || !$v.keyAndPassword.newPassword.maxLength"
					>{{$t('A jelszó minimum 8 és maximum 20 karakter hosszú lehet!')}}</span>
                    <span v-else-if="!$v.keyAndPassword.newPassword.goodPassword"
					>{{$t('A jelszónak tartalmaznia kell kis betűt, nagy betűt és számot!')}}</span>
				</div>
			</div>

			<div class="form-group form-group--password form-group--with-icon pb-4">
				<input
					ref="passwordConfirm"
					v-model.trim="$v.passwordConfirm.$model"
					v-input-class
					:type="showPasswordConfirm? 'text' : 'password'"
					class="input"
					:placeholder="$t('Jelszó ismét')"
				/>
				<span class="input__icon">
					<inline-svg :src="require('@/assets/icons/lock.svg')"></inline-svg>
				</span>
                <button
					type="button"
					@click.prevent.stop="showPasswordConfirm = !showPasswordConfirm"
					class="input__show-password"
				>
                    <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
				</button>
				<div class="input__error" v-show="$v.passwordConfirm.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.passwordConfirm.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span v-else-if="!$v.passwordConfirm.sameAsPassword">{{$t('A beírt jelszavak nem egyeznek!')}}</span>
				</div>
			</div>

            <div class="form-group form-group--checkbox text-left">
					<div class="checkbox">
						<input
							v-model="$v.tosAccepted.$model"
							type="checkbox"
							id="tosAccepted"
							class="checkbox__input"
						/>
						<label for="tosAccepted" class="checkbox__label"></label>
					</div>

					<label for="tosAccepted" v-html="$t('Elfogadom az {linkStart}Általános Szerződési feltételeket{linkEnd}', {'linkStart': '<a href=\'/docs/terms_of_service.pdf\' target=\'_blank\'>', 'linkEnd': '</a>'})">
					</label>
				</div>

            <div class="form-group form-group--checkbox text-left">
					<div class="checkbox">
						<input
							v-model="$v.privacyAccepted.$model"
							type="checkbox"
							id="privacyAccepted"
							class="checkbox__input"
						/>
						<label for="privacyAccepted" class="checkbox__label"></label>
					</div>

					<label for="privacyAccepted" v-html="$t('Elfogadom az {linkStart}Adatvédelmi Szabályzatot{linkEnd}', {'linkStart': '<a href=\'/docs/privacy_policy.pdf\' target=\'_blank\'>', 'linkEnd': '</a>'})">
					</label>
				</div>

            <div class="pb-4">
                <button type="submit" :disabled="$v.$invalid" class="button w-100">{{$t('Mentés')}}</button>
            </div>

        </form>
	</div>
</template>

<script>
import { finishPasswordResetUsingPOST } from "@/api.js";
import { KeyAndPasswordVM } from "@/models";
import Password from '@/components/PasswordStrengthMeter.vue'
import {
	required,
	maxLength,
	minLength,
	sameAs,
} from "vuelidate/lib/validators";
export default {
    name: "ResetPassword",
    components: { Password },
	data() {
		return {
            keyAndPassword: new KeyAndPasswordVM(),
            privacyAccepted: false,
            tosAccepted: false,
            passwordConfirm: null,
            showPassword: false,
            showPasswordConfirm: false
		};
    },
	validations: {
		keyAndPassword: {
			newPassword: {
                required,
				minLength: minLength(8),
                maxLength: maxLength(100),
                goodPassword:(password) => {
                    return /[a-z]/.test(password) &&
                    /[A-Z]/.test(password) &&
                    /[0-9]/.test(password)
                }
			},
		},
		passwordConfirm: {
			required,
			sameAsPassword: sameAs(function () {
				return this.keyAndPassword.newPassword;
			}),
        },
        privacyAccepted: {
            sameAs: sameAs( () => true )
        },
        tosAccepted: {
            sameAs: sameAs( () => true )
        }
	},
    methods: {
		submit: function () {
			finishPasswordResetUsingPOST({ keyAndPassword: this.keyAndPassword })
				.then((response) => {
					this.$swal({
							title: this.$t("Jelszó módosítás"),
							text: this.$t("A jelszó módosítás sikeres volt, most már bejelentkezhez."),
                            imageUrl: window.swalSuccess,
                            confirmButtonText: this.$t('Bejelentkezés')
					}).then(() => {
                            this.$router.push({ name: "login" });
                    });
				})
				.catch((err) => {
                    if (err.status === 404) {
						return this.$swal({
							title: this.$t("Jelszó módosítás"),
							text: this.$t("Nem megfelelő a jelszó módosítási hivatkozás."),
							imageUrl: window.swalError,
						});
					}
                    this.$swal({
                            title: this.$t("Jelszó módosítás"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
					console.warn(err);
				});
		},
	},
	created() {
		if (!this.$route.query.key) {
			return this.$swal({
				title: this.$t("Jelszó módosítás"),
				text: this.$t("Nem megfelelő a jelszó módosítási hivatkozás!"),
				imageUrl: window.swalError,
			}).then(() => {
				this.$router.replace({ name: "login" });
			});
		}
		this.keyAndPassword.key = this.$route.query.key;
	},
};
</script>

<style lang="scss">
.input__show-password {
    .svg-fill {
        fill: #333333;
    }
}
.input__icon {
    .svg-fill {
        fill: #CDCDCD;
    }
}
</style>